import React, { useEffect } from 'react'
import moment from 'moment'
import { observer } from 'mobx-react-lite'
import { Row, Col, Text } from '@evertel/web/ui'
import { DocumentIcon } from './DocumentIcon'
import { APIDataDocument, APIDataDocumentSchema } from '@evertel/types'
import { useService } from '@evertel/di'
import { DepartmentController } from '@evertel/department'

interface Props {
    schema: APIDataDocumentSchema
    document?: APIDataDocument
}

const DocumentFooter: React.FC<Props> = observer(({
    document,
    schema
}) => {

    const departmentController = useService(DepartmentController, [document?.departmentId])

    useEffect(() => {
        (async () => {
            departmentController.init(document?.departmentId)
        })()
    }, [document?.departmentId])

    const department = departmentController.department || {}

    return (
        <Row className="m-0" valign="center">
            <DocumentIcon
                schema={schema}
                width={35}
                height={35}
            />
            <Col className="ms-2">
                <Text bold>
                    {schema?.name} {(department) && `(${department.name})`}
                </Text>
                {!!document && (
                    <Text size={12} >
                        Last Updated: {moment(document?.updatedDate).format('ll @ HH:mm')}
                        &nbsp; | &nbsp;
                        {`ID: d${document?.id}.s${document?.documentSchemaId}.r${document?.documentSchemaRevisionId ?? 0}`}
                    </Text>
                )}
            </Col>
        </Row>
    )
})

export {
    DocumentFooter
}
